import React, { FC, memo } from 'react';
import { IPrivacyPolicyPage, ITermsOfUsePage } from '@montana/models/generated/cms.interface';
import { Container } from '@montana/shared/container';
import { RichText } from '@montana/shared/rich-text';
import { DynamicBlocks } from '@montana/blocks/dynamic-blocks.component';

export const TermsAndConditionsPage: FC<IPrivacyPolicyPage | ITermsOfUsePage> = memo(({ blocks, content }: IPrivacyPolicyPage | ITermsOfUsePage): JSX.Element => {

    return (
        <Container className="terms-and-conditions">
            <DynamicBlocks blocks={blocks} />
            {content && <RichText className="app__block terms-and-conditions__text" text={content} />}
        </Container>
    );
});
